import { takeLatest, call, put } from "redux-saga/effects";

import MetadataService from "../../../services/Metadata/MetadataService";
import * as types from "../actionTypes";

export function* getMetadataInfoWatcherSaga() {
  yield takeLatest(types.API_V1_GET_METADATA_INFO_REQUEST, workerSaga);
}

export function* workerSaga({ accountIds }) {
  try {
    const data = yield call(MetadataService.getMetadataInfo, accountIds);

    if (data) {
      yield put({
        type: types.API_V1_GET_METADATA_INFO_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    yield put({ type: types.API_V1_GET_METADATA_INFO_FAILURE });
    return { error: error };
  }
}
